module.exports = __webpack_public_path__ + "img/corridor-entrance.c8c9f06.svg";